import React, { JSX } from 'react';

import { useTranslations } from '../../../contexts/LocalizationContext';
import MainPageHeading from '../MainPageHeading/MainPageHeading';

export const NoLiveLocationsHeader = (): JSX.Element => {
  const translations = useTranslations();
  return <MainPageHeading>{translations('no_live_locations_header')}</MainPageHeading>;
};
